// Customization: Minimal langmap with only languages we support in locales/
// Added "se" for Northern Sámi (Plone uses "se", Volto only has "se-NO")
const langmap = new Proxy(
  {
    de: { nativeName: 'Deutsch', englishName: 'German' },
    en: { nativeName: 'English', englishName: 'English' },
    es: { nativeName: 'Español', englishName: 'Spanish' },
    eu: { nativeName: 'Euskara', englishName: 'Basque' },
    fi: { nativeName: 'Suomi', englishName: 'Finnish' },
    fr: { nativeName: 'Français', englishName: 'French' },
    it: { nativeName: 'Italiano', englishName: 'Italian' },
    ja: { nativeName: '日本語', englishName: 'Japanese' },
    nl: { nativeName: 'Nederlands', englishName: 'Dutch' },
    pt: { nativeName: 'Português', englishName: 'Portuguese' },
    'pt-BR': {
      nativeName: 'Português (Brasil)',
      englishName: 'Portuguese (Brazil)',
    },
    ro: { nativeName: 'Română', englishName: 'Romanian' },
    se: { nativeName: 'Davvisámegiella', englishName: 'Northern Sámi' },
    sv: { nativeName: 'Svenska', englishName: 'Swedish' },
  },
  {
    get: function (obj, lang) {
      if (lang.includes('-')) {
        lang = lang.split('-');
        lang = `${lang[0]}-${lang[1].toUpperCase()}`;
      } else if (lang.includes('_')) {
        lang = lang.split('_');
        lang = `${lang[0]}-${lang[1].toUpperCase()}`;
      }
      return obj[lang];
    },
  },
);

export default langmap;
